import * as product from '@/store/modules/product.js'
import { DataService } from '@/services/DataService.js'

export const namespaced = true

export const modules = {
  product
}

export const state = {
  statuses: [],
  users: [],
  companies: []
}

export const getters = {
  statuses (state) {
    return state.statuses
  },
  status (state) {
    return (id) => {
      return state.statuses.find((p) => {
        return p.id === id
      })
    }
  },
  status_by_code (state) {
    return (code) => {
      return state.statuses.find((p) => {
        return p.code === code
      })
    }
  },
  users (state) {
    return state.users
  },
  user (state) {
    return (id) => {
      return state.users.find((u) => {
        return u.id === id
      })
    }
  },
  companies (state) {
    return state.companies
  },
  companу (state) {
    return (id) => {
      return state.companies.find((p) => {
        return p.id === id
      })
    }
  }
}

export const mutations = {
  SET_STATUSES (state, data = []) {
    state.statuses = data
  },
  SET_USERS (state, data = []) {
    state.users = data
  },
  SET_COMPANIES (state, data = []) {
    state.companies = data
  }
}

export const actions = {
  async loadStatuses ({ commit }) {
    return DataService.getContractStatuses()
      .then(({ data: { contract_status: contractStatus } }) => {
        commit('SET_STATUSES', contractStatus)
      })
  },
  async loadContractsUsers ({ commit, getters }) {
    const usersIds = getters.contracts?.reduce((acc, cont) => {
      if (cont.user_id) {
        acc.add(cont.user_id)
      }
      if (cont.counteragent_user_id) {
        acc.add(cont.counteragent_user_id)
      }
      return acc
    }, new Set([]))
    return DataService.getUsers(Array.from(usersIds))
      .then(({ data: { users } }) => {
        commit('SET_USERS', users.map(u => {
          return {
            id: u.id,
            name: u.fullName
          }
        }))
      })
  }
  /*
  async loadContractsCompanies ({ commit, getters }) {
    const companiesIds = getters.contracts?.reduce((acc, cont) => {
      if (cont.company_id) {
        acc.add(cont.company_id)
      }
      if (cont.subsidiary_id) {
        acc.add(cont.subsidiary_id)
      }
      if (cont.counteragent_company_id) {
        acc.add(cont.counteragent_company_id)
      }
      return acc
    }, new Set([]))
    return DataService.getCompanies({ filter: { id: Array.from(companiesIds) }, offset: 0, limit: 10000 })
      .then(({ data: { company: { data } } }) => {
        commit('SET_COMPANIES', data)
      })
  }
  */
}
